export default __webpack_public_path__ + "static/media/7-sgi-matricula-v2-02.png:Zone.0543b9e3.Identifier";